import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

const PrivateRoute = ({ element, allowedRoles = [] }) => {
  const { currentUser, isLoading, authChecked } = useAppContext();
  const location = useLocation();

  // Don't render anything until we've checked authentication
  if (!authChecked) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  // Show loading indicator while checking authentication
  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  // Check if user is authenticated
  if (!currentUser) {
    // Redirect to login page, but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user needs onboarding (except if already on setup pages)
  if (currentUser && !currentUser.onboarding_completed && !location.pathname.startsWith('/setup')) {
    return <Navigate to="/setup/onboarding" replace />;
  }

  // Check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser.role)) {
    // User doesn't have the required role
    return <Navigate to="/unauthorized" replace />;
  }

  // User is authenticated and has required role, render the element
  return element;
};

export default PrivateRoute;